import React from 'react';
import { motion } from 'framer-motion';
interface ToggleProps {
  value: 'roadways' | 'railways';
  onChange: (value: 'roadways' | 'railways') => void;
}
export function Toggle({
  value,
  onChange
}: ToggleProps) {
  return <div className="bg-white/20 p-1 rounded-full flex items-center relative w-48 h-10 backdrop-blur-sm border border-white/10" data-id="element-1116">
      {/* Sliding background */}
      <motion.div className="absolute top-1 bottom-1 bg-white rounded-full shadow-sm" initial={false} animate={{
      left: value === 'roadways' ? '4px' : '50%',
      width: 'calc(50% - 4px)',
      x: value === 'railways' ? '0%' : '0%'
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} data-id="element-1117" />

      <button onClick={() => onChange('roadways')} className={`flex-1 relative z-10 text-sm font-semibold transition-colors duration-200 ${value === 'roadways' ? 'text-orange-600' : 'text-white hover:text-white/90'}`} data-id="element-1118">
        Roadways
      </button>

      <button onClick={() => onChange('railways')} className={`flex-1 relative z-10 text-sm font-semibold transition-colors duration-200 ${value === 'railways' ? 'text-orange-600' : 'text-white hover:text-white/90'}`} data-id="element-1119">
        Railways
      </button>
    </div>;
}